import { FC, useEffect, useState } from 'react';
import { Dialog } from './dialog';
import { useAppContext } from '../../contexts/app_context';
import { useConfetti } from '../../hooks/use_confetti';
import { useSearchParams } from 'react-router-dom';

export const PrizeDialog: FC = () => {
    const [value, set_value] = useState<string>('');
    const [params] = useSearchParams();
    const { cancel_action } = useAppContext();
    const confetti_ref = useConfetti({ max_particles: 100, speed: 100, play: true });

    useEffect(() => {
        const prize = params.get('prize_value');
        if (!prize) return cancel_action();
        set_value(prize);
    }, [params, cancel_action]);

    return (
        <div className='prize-dialog'>
            <Dialog title='Congrats!' onClose={cancel_action}>
                <div>You got {value}!</div>
            </Dialog>
            <canvas
                ref={confetti_ref}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    pointerEvents: 'none',
                    zIndex: 99,
                }}
            />
        </div>
    );
};
